import { render } from "./PageNotDeveloped.vue?vue&type=template&id=5d726c18&scoped=true"
import script from "./PageNotDeveloped.vue?vue&type=script&lang=js"
export * from "./PageNotDeveloped.vue?vue&type=script&lang=js"

import "./PageNotDeveloped.vue?vue&type=style&index=0&id=5d726c18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d726c18"]])

export default __exports__